'use client';

import { CountdownDigits } from './CountdownDigits';
import type { UrgencyBarProps } from './types';
import { UrgencyBarText } from './UrgencyBarText';
import { useUrgencyBar } from './useUrgencyBar';

export function UrgencyBar(props: UrgencyBarProps) {
  const {
    backgroundClassName,
    countdown,
    countdownUnits,
    deadlineText,
    flashDealLabel,
    secondaryText,
    showCountdown,
    textClassName,
  } = useUrgencyBar(props);

  return (
    <div
      className={`flex min-h-13 w-full items-center gap-1 overflow-hidden rounded-radius/card border border-borders/default px-spacing/padding/x py-spacing/padding/y-sm ${backgroundClassName}`}
    >
      {showCountdown ? (
        <CountdownDigits
          className={textClassName}
          units={countdownUnits}
          value={countdown}
        />
      ) : null}
      <UrgencyBarText
        deadlineText={deadlineText}
        flashDealLabel={flashDealLabel}
        secondaryText={secondaryText}
        textClassName={textClassName}
      />
    </div>
  );
}
